module.exports = "<svg id=\"2e001873-fe05-4a04-99ba-a7212cc9cbbc\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 43 69.21\"><title>NextLft</title><g id=\"a1e1229b-b22c-4740-9cc7-8972bb5eed85\" data-name=\"Page-1\"><g id=\"4f6a0afe-9615-4832-bff5-9eb847caa4e1\" data-name=\"Artboard\"><polygon id=\"7424e461-eeff-4438-8785-0a59d9f84623\" data-name=\"Fill-1\" points=\"43 0 43 22.8 28 34.6 43 46.41 43 69.21 0 34.6 43 0\" style=\"fill:#6dc200\"></polygon></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/left.svg
// module id = XtuF
// module chunks = 0